import { createAction } from '../helpers';

export const toggleMobileMenu = createAction('TOGGLE_MOBILE_MENU');
export const toggleStylingMode = createAction('TOGGLE_STYLING_MODE');
export const toggleMobileContainer = createAction('TOGGLE_MOBILE_CONTAINER');

export const setMessage = createAction('SET_MESSAGE');

export const setConversationsFilter = createAction('SET_CONVERSATIONS_FILTER');

export const setPagePreview = createAction('SET_PAGE_PREVIEW');
export const setPageBlockPreview = createAction('SET_PAGE_BLOCK_PREVIEW');

export const setBackTrack = createAction('SET_BACK_TRACK');
